<div class="product-card">
  <div class="product-image" [routerLink]="['/product-detail',product.slug]">
    <img [src]="imageUrl+'/'+product.imageName" [alt]="product.pname">
  </div>

  <div class="product-content">
    <h3 class="product-title">
      <a [routerLink]="['/product-detail',product.slug]">{{ product.pname }}</a>
    </h3>
    <div class="product-price">
      <span class="original-price">₹ {{ product.mrp.toFixed(2) }}</span>
      <span class="current-price">₹ {{ product.discountPrice.toFixed(2) }}</span>
    </div>
    <div class="product-actions">
      <button class="theme-btn" [disabled]="!product.isStockPresent" (click)="addToCart()">
        {{ product.isStockPresent ? 'Add To Cart' : 'Out of stock' }}
      </button>
    </div>
  </div>
</div>